import ErrorBoundary from '@/components/ErrorBoundary';
import { StandaloneHeading } from '@/components/content/Heading';
import { componentClassName } from '@/styles/ContentHeading';
import { DefaultComponent } from '@/types/component';
import { withDebugMetadata, withSafeInnerHTML } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';

export const MabraStandaloneHeading: typeof StandaloneHeading = ({ content, tag, options, ...props }) => {
  const Component = tag ?? 'h2';
  const className = componentClassName('', {});

  return (
    <ErrorBoundary>
      <Component {...mergeProps({ className }, options as any)} {...props} {...withSafeInnerHTML(content)} />
    </ErrorBoundary>
  );
};

const MabraDefaultHeading: DefaultComponent = ({ type, data, meta, descendants }) => {
  return (
    <MabraStandaloneHeading
      content={data.content}
      tag={data.tag}
      options={{
        //@ts-expect-error
        className: meta.className,
      }}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export const standalone = MabraStandaloneHeading;

export default MabraDefaultHeading;
